import environment from "../env/env";

export const KEY_STORAGE = environment.production ? "DPLOY_APP" : "DPLOY_TEST";
export const LOADING = "LOADING";
export const ALERT = "ALERT";
export const ONLINE = "ONLINE";
export const SIGNIN = "SIGNIN";
export const SIGNOUT = "SIGNOUT";
export const SET_PROFILE = "SET_PROFILE";
export const SET_PROJECT = "SET_PROJECT";
export const SET_FOLDERS = "SET_FOLDERS";
export const SET_FOLDER = "SET_FOLDER";
export const SET_DISPLAY = "SET_DISPLAY";
export const SET_VAR = "SET_VAR";
export const SET_PAY = "SET_PAY";
export const SET_VIEW_ROWS = "SET_VIEW_ROWS";
export const SET_SLOPE = "SET_SLOPE";

/** Talking */
export const TALKING = "TALKING";
